const About = (props) => {
  return (
    <div>
      <h3>about - values, numbers, team, careers</h3>
    </div>
  );
}
export default About;